import {
    useContext,
    createContext
} from 'react'

const Context = createContext()

export default function EasyProvider({children, value}) {
    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    )
}

export const useEasyProvider = () => useContext(Context)